import React from 'react';
import { Check } from 'lucide-react';

interface StepIndicatorProps {
  steps: string[];
  currentStep: number;
}

export default function StepIndicator({ steps, currentStep }: StepIndicatorProps) {
  return (
    <div className="flex items-center justify-center gap-0 max-w-2xl mx-auto">
      {steps.map((step, index) => (
        <React.Fragment key={`step-indicator-${step}`}>
          <div className="flex flex-col items-center gap-1.5">
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-mono-data font-semibold border-2 transition-all duration-300 ${
                index < currentStep
                  ? 'bg-primary border-primary text-primary-foreground'
                  : index === currentStep
                  ? 'bg-primary/15 border-primary text-primary' :'bg-muted border-border text-muted-foreground'
              }`}
            >
              {index < currentStep ? <Check size={14} /> : index + 1}
            </div>
            <span
              className={`text-[10px] font-mono-data hidden sm:block whitespace-nowrap ${
                index === currentStep ? 'text-primary' : index < currentStep ? 'text-foreground' : 'text-muted-foreground'
              }`}
            >
              {step}
            </span>
          </div>
          {index < steps.length - 1 && (
            <div
              className={`flex-1 h-px mx-2 mb-4 transition-all duration-300 ${
                index < currentStep ? 'step-connector-active' : 'step-connector'
              }`}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}